import React from 'react';
import MainLayout from '../../components/layout/MainLayout';
import { useNavigate } from 'react-router-dom';
import { Download, ExternalLink } from 'lucide-react';

const Reports = () => {
  const navigate = useNavigate();

  return (
    <MainLayout title="Reports & Analytics">
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '20px', marginTop: '20px' }}>
        
        {/* Export Leads Card */}
        <div style={{
          background: 'var(--color-surface, #fff)',
          border: '1px solid var(--color-border-tertiary)',
          borderRadius: 'var(--border-radius-lg)',
          padding: '24px',
          display: 'flex',
          flexDirection: 'column',
          gap: '16px'
        }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
            <div style={{ background: '#f0fdf4', color: '#16a34a', padding: '12px', borderRadius: '12px' }}>
              <Download size={24} />
            </div>
            <div>
              <h2 style={{ fontSize: '18px', fontWeight: '600', color: 'var(--color-text-primary)', margin: 0 }}>Export Your Leads</h2>
              <p style={{ fontSize: '13px', color: 'var(--color-text-secondary)', margin: '4px 0 0 0' }}>
                Download your leads in Excel or CSV format
              </p>
            </div>
          </div>
          
          <div style={{ background: 'var(--color-background-secondary)', padding: '16px', borderRadius: '8px', fontSize: '13px', color: 'var(--color-text-secondary)', lineHeight: '1.5' }}>
            You can now export your leads directly from the Leads page. Use the filters to narrow down your results, then click the <strong>Export</strong> button to download. 
            <br/><br/>
            You only have access to export leads that are assigned to you or within your visibility scope.
          </div>

          <button 
            onClick={() => navigate('/leads')}
            style={{
              marginTop: 'auto',
              display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px',
              width: '100%', padding: '12px', background: 'var(--color-brand-primary)', color: 'white',
              border: 'none', borderRadius: '8px', fontWeight: '600', cursor: 'pointer', fontSize: '14px'
            }}
          >
            Go to Leads & Export
            <ExternalLink size={16} />
          </button>
        </div>

        {/* Coming Soon Card */}
        <div style={{
          background: 'var(--color-background-info)',
          border: '1px solid var(--color-brand-primary)',
          borderRadius: 'var(--border-radius-lg)',
          padding: '30px',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          textAlign: 'center',
          gap: '16px',
          color: 'var(--color-brand-primary)'
        }}>
          <span style={{ fontSize: '48px' }} role="img" aria-label="rocket">🚀</span>
          <div>
            <h2 style={{ fontSize: '20px', fontWeight: '700', marginBottom: '8px' }}>Advanced Reporting is Coming Soon!</h2>
            <p style={{ fontSize: '15px', color: 'var(--color-text-secondary)', maxWidth: '500px', margin: '0 auto' }}>
              We're currently building powerful new analytics and reporting tools. Check back later to see comprehensive insights into your team's performance.
            </p>
          </div>
        </div>

      </div>
    </MainLayout>
  );
};

export default Reports;
